import React from 'react';
import { ResponseStatusAvatar, responseStatusAdminId } from '../../workAvailability/ResponseStatusProvider';
import ChatMessageRow from './ChatMessageRow';
import ChatMessageContent from './ChatMessageContent';
import ChatLinkPreviewList from './ChatLinkPreviewList';
import {
  buildGroupMessageContentProps,
  buildGroupMessageRowViewModel,
} from './groupMessageRowViewUtils';
import ChatQuestionCard from '../questions/ChatQuestionCard';
import ChatWorkAvailabilityNotices from './ChatWorkAvailabilityNotices';

export default function GroupStandardMessageRow({
  message,
  presentation,
  isSelf,
  variant = 'plain',
  selfBubbleClass,
  otherBubbleClass,
  timeLabel = '',
  rowClassName = '',
  activeAnchorMessageId,
  anchorClassName = 'is-anchor-hit',
  avatarClassName,
  avatarClickableClassName = '',
  avatarFallbackClassName,
  avatarFallbackStyle,
  avatarAlt = '',
  onAvatarClick,
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
  onImageClick,
  onMentionClick,
  fileVariant = 'simple',
  bubbleClassName = '',
  sideActionContent = null,
  replyHeaderContent = null,
  wrapContent = null,
  footerContent = null,
  metaEndContent = null,
}) {
  const rowProps = buildGroupMessageRowViewModel({
    message,
    presentation,
    isSelf,
    variant,
    selfBubbleClass,
    otherBubbleClass,
    timeLabel,
    activeAnchorMessageId,
    anchorClassName,
    avatarClassName,
    avatarClickableClassName,
    avatarFallbackClassName,
    avatarFallbackStyle,
    avatarAlt,
    onAvatarClick,
    onContextMenu,
    onTouchStart,
    onTouchEnd,
    onTouchCancel,
    onTouchMove,
  });

  const contentNode = (
    <ChatMessageContent
      {...buildGroupMessageContentProps({
        message,
        presentation,
        onImageClick,
        onMentionClick,
        fileVariant,
      })}
    />
  );

  const linkPreviewCards = message?.linkPreview || message?.linkPreviews?.length
    ? <ChatLinkPreviewList message={message} />
    : null;
  const questionCard = message?.question ? <ChatQuestionCard question={message.question} /> : null;
  const hasAvailabilityNotice = Array.isArray(message?.work_availability_notices)
    ? message.work_availability_notices.length > 0
    : Array.isArray(message?.workAvailabilityNotices) && message.workAvailabilityNotices.length > 0;
  const availabilityNotice = hasAvailabilityNotice ? <ChatWorkAvailabilityNotices message={message} /> : null;
  const mergedFooter = (linkPreviewCards || questionCard || footerContent || availabilityNotice)
    ? (<>{linkPreviewCards}{questionCard}{availabilityNotice}{footerContent}</>)
    : null;

  return (
    <ChatMessageRow
      key={message?.id}
      {...rowProps}
      avatarNode={rowProps.avatarNode ? <ResponseStatusAvatar adminUserId={responseStatusAdminId(message)} badgePlacement="avatar">{rowProps.avatarNode}</ResponseStatusAvatar> : null}
      rowClassName={rowClassName}
      bubbleClassName={bubbleClassName ? `${rowProps.bubbleClassName || ''} ${bubbleClassName}`.trim() : rowProps.bubbleClassName}
      sideActionContent={sideActionContent}
      footerContent={mergedFooter}
      metaEndContent={metaEndContent}
    >
      <>
        {replyHeaderContent}
        {typeof wrapContent === 'function' ? wrapContent(contentNode, message) : contentNode}
      </>
    </ChatMessageRow>
  );
}
